module.exports = __webpack_public_path__ + "img/csong.87ced5ac.png";